module.exports = __webpack_public_path__ + "static/media/roble_umber.ad8fe90f.jpg";